import React from "react";
import { Grid, Container } from "@mui/material";

import WelcomeCard from "../Applications/CMS/WelcomeCard";
import RMSWidget from "../Applications/RMS/RMSWidget";
import JPWidget from "../Applications/JP/JPWidget";
import MSFWidget from "../Applications/MSF/MSFWidget";
import PORTWidget from "../Applications/PORT/PORTWidget";
import TMSWidget from "../Applications/TMS/TMSWidget";
import RSWidget from "../Applications/RS/RSWidget";

import { useSelector, useStore } from "react-redux";
import { getApplicationCodes, getRmsAppCode } from "../../reducers";
import BreadcrumbBuilder from "../Common/Breadcrumbs/BreadcrumbBuilder";
import CENTWidget from "../Applications/CENT/CENTWidget";

function Dashboard() {
    const codes = useSelector(getApplicationCodes) || [];
    const store = useStore();
    const user = store.getState().user || {};
    const rmsApp = useSelector(getRmsAppCode);

    return (
        <Container className="content">
            <Grid container spacing={3} className="card-grid">
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                <Grid item xs={12}>
                    <WelcomeCard
                        organisation={user?.organisation?.uuid ?? null}
                    />
                </Grid>

                {!!rmsApp && (
                    <Grid item xs={12} className="card-grid-item">
                        <RMSWidget appCode={rmsApp} />
                    </Grid>
                )}

                {(!!rmsApp || codes.includes("C-PORT")) && (
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        xl={4}
                        className="card-grid-item"
                    >
                        <CENTWidget appCode={rmsApp} />
                    </Grid>
                )}

                {codes.includes("P-JP") && (
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        xl={4}
                        className="card-grid-item"
                    >
                        <JPWidget />
                    </Grid>
                )}
                {codes.includes("Z-RS") && (
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        xl={4}
                        className="card-grid-item"
                    >
                        <RSWidget />
                    </Grid>
                )}
                {(codes.includes("P-MSF") ||
                    codes.includes("C-MSF") ||
                    codes.includes("E-MSF")) && (
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        xl={4}
                        className="card-grid-item"
                    >
                        <MSFWidget />
                    </Grid>
                )}
                {codes.includes("C-TMS") && (
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        xl={4}
                        className="card-grid-item"
                    >
                        <TMSWidget />
                    </Grid>
                )}
                {(codes.includes("P-RMSD") ||
                    codes.includes("P-RMSN") ||
                    codes.includes("C-PORT")) && (
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        xl={4}
                        className="card-grid-item"
                    >
                        <PORTWidget />
                    </Grid>
                )}
            </Grid>
        </Container>
    );
}

export default Dashboard;
